import _ from 'underscore';
import { getEntityCollectionName } from '../common/pluralize-entity';
import {
  ActionSlices,
  ActionVerbs,
  ActionStages,
  splitActionName,
} from '../common/action-utilities';

export const initialEntityState = {
  lastUpdated: undefined,
  isLoading: false,
  data: null,
  error: null,
};

function handleRead(state, params, stage) {
  switch (stage) {
    case ActionStages.start: {
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    }
    case ActionStages.complete: {
      const { value, actionTime } = params;
      return {
        ...state,
        lastUpdated: actionTime,
        isLoading: false,
        data: value || [],
        error: null,
      };
    }
    case ActionStages.fail: {
      // TODO: when read fails, we need to roll back the query parameters to allow retry.
      const { error } = params;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    default:
      return state;
  }
}

function handleUpdate(state, params, stage) {
  const {
    actionTime, // timestamp when action happens
  } = params;

  const updateData = (id, data) => {
    if (state.data) {
      return _.map(state.data, (item) => {
        if (item.id === id) {
          return data;
        }

        return item;
      });
    }

    return null;
  };

  switch (stage) {
    case ActionStages.start: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionStages.complete: {
      const { id, data } = params;
      return {
        ...state,
        lastUpdated: actionTime,
        isLoading: false,
        data: updateData(id, data),
        error: null,
      };
    }
    case ActionStages.fail: {
      const { error } = params;

      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    default:
      return state;
  }
}

function handleCreate(state, params, stage) {
  const {
    actionTime,
  } = params;

  switch (stage) {
    case ActionStages.start: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionStages.complete: {
      const { value } = params;

      return {
        ...state,
        lastUpdated: actionTime,
        isLoading: false,
        data: [...state.data || [], value],
        error: null,
      };
    }
    case ActionStages.fail: {
      const { error } = params;

      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    default:
      return state;
  }
}

export function ccReducerCreator(entityName) {
  return (state = initialEntityState, action) => {
    const {
      params = {},
    } = action;

    const {
      slice,
      label,
      verb,
      stage,
    } = splitActionName(action);

    if (slice !== ActionSlices.ccEntity) {
      return state;
    }

    if (label && label !== getEntityCollectionName(entityName) && label !== entityName) {
      return state;
    }

    switch (verb) {
      case ActionVerbs.reset:
        return initialEntityState;
      case ActionVerbs.read:
        return handleRead(state, params, stage);
      case ActionVerbs.update:
        return handleUpdate(state, params, stage);
      case ActionVerbs.create:
        return handleCreate(state, params, stage);
      default:
        return state;
    }
  };
}
